import React from 'react'
import "./HotDeal.css";

const HotDeal = () => {
  return (
    <div className='hotDeal-cont'>
      <div className='text-center rajdhani-font text-6xl'>
        <p className='text-xl text-yellow-500'>H u r r y <span className='pl-3'>U p</span></p>
        <p>Hot Deal! Sale <span className='orange-color'>20% Off</span></p>
        <p className='text-2xl'>Shop Now</p>
      </div>
    </div>
  )
}

export default HotDeal